/**
 * Password Protection Configuration
 * Simple password to protect the app from unauthorized access
 */

export const AUTH_CONFIG = {
  // Change this to your desired password
  // This is a simple password for family use only
  PASSWORD: 'english2024',

  // Session duration in hours (after this, need to re-enter password)
  SESSION_DURATION: 24,

  // Enable password protection (set to false to disable)
  ENABLE_PASSWORD: true,
};

/**
 * How to use:
 *
 * 1. Change the PASSWORD above to something you and your child know
 * 2. Share this password only with your child
 * 3. Even if someone gets the app URL, they can't use it without the password
 *
 * Security note:
 * This is a simple client-side password for convenience.
 * For stronger security, consider server-side authentication.
 */